import React from 'react';
import { Spin } from 'antd';
import intl from 'react-intl-universal';

import { parseFen2Currency } from '@/utils/number';

import commonStyles from '../common.module.scss';

function Info(props) {
  const { info, infoLoading } = props;

  return (
    <Spin spinning={infoLoading}>
      <dl className={commonStyles['bill-block']}>
        <dt className={commonStyles['bill-block-title']}>
          {intl.get('bill_part_settle_account_total')}
        </dt>
        <dd>
          <label className="text-colon" style={{ minWidth: '10%' }}>
            {intl.get('bill_part_settle_has_paid')}
          </label>
          <span>
            {parseFen2Currency(info.payAmount)}
            {info.ota ? (
              <span style={{ fontSize: 12, color: '#969799', marginLeft: 5 }}>
                (
                <label className="text-colon" style={{ minWidth: '10%' }}>
                  {intl.get('bill_part_settle_include_ota_advance')}
                </label>
                <span className="amount-hint" style={{ fontSize: 12 }}>
                  {parseFen2Currency(info.ota)}
                </span>
                )
              </span>
            ) : (
              ''
            )}
          </span>
        </dd>
        <dd>
          <label className="text-colon" style={{ minWidth: '10%' }}>
            {intl.get('bill_part_settle_has_consumed_total')}
          </label>
          <span>{parseFen2Currency(info.consumeAmount)}</span>
        </dd>
        <dd>
          <label className="text-colon" style={{ minWidth: '10%' }}>
            {intl.get('bill_part_settle_coupon_discount')}
          </label>
          <span>{parseFen2Currency(info.discountAmount)}</span>
        </dd>
      </dl>
    </Spin>
  );
}

export default Info;
